module.exports = __webpack_public_path__ + "static/media/bedrooms.576cc76a.svg";